import { LocationCode } from '@geneplanet/ngx-utils/src/lib/localization';
import { environment } from 'src/environments/environment';

export const isFeatureActive = (
  locationCode: LocationCode,
  featureName: string
): boolean => {
  const feature = environment.features[featureName];

  // By default feature is active
  if (feature === undefined) {
    return true;
  }

  // It's localized
  if (typeof feature === 'object') {
    return feature[locationCode] !== false;
  }

  return feature;
};
